import { useEffect } from "react";
import { preloadRouteChunksWhenIdle } from "../../utils/routePreload";

function RoutePreloader() {
  useEffect(() => {
    const startPreload = () => preloadRouteChunksWhenIdle();

    if (document.readyState === "complete") {
      startPreload();
    } else {
      window.addEventListener("load", startPreload, { once: true });
    }
  }, []);

  return null;
}

export default RoutePreloader;
